export function ScaleLegend({ first, last }) {
  return (
    <div className="d-flex align-items-center w-100 py-4">
      <div className="fw-bold me-2">{first}</div>
      <i className="fas fa-chevron-left fs-3 text-primary"></i>
      <div className="h-1px bg-primary flex-grow-1"></div>
      <i className="fas fa-chevron-right fs-3 text-primary"></i>
      <div className="fw-bold ms-2">{last}</div>
    </div>
  );
}
